import React from "react";
import { Redirect, Route, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import {
  object as objectPropType,
  array as arrayPropType,
  func,
  oneOfType,
} from "prop-types";
import { isJnnPartnerLink } from "../utils/acquisitionTracking";

/**
 * @function PublicRoute
 * @description - constructs the applications public route layout
 * @returns {JSX} - JSX
 */
const PublicRoute = ({ component: Component, ...rest }) => {
  const { isAuthenticated } = useSelector((store) => store.auth);
  const location = useLocation();

  const getAuthenticatedRedirect = () => {
    if (isJnnPartnerLink(location.search)) {
      return "/job-match-score";
    }

    if (location.pathname.startsWith("/job-lists-details")) {
      return {
        pathname: location.pathname.replace(/^\/job-lists-details/, "/home"),
        search: location.search,
        hash: location.hash,
      };
    }

    return {
      pathname: "/home",
      search: location.search,
      hash: location.hash,
    };
  };

  return (
    <Route
      {...rest}
      render={() =>
        isAuthenticated ? (
          <Redirect to={getAuthenticatedRedirect()} />
        ) : (
          <Component />
        )
      }
    />
  );
};

PublicRoute.propTypes = {
  component: oneOfType([arrayPropType, objectPropType, func]).isRequired,
};

export default PublicRoute;
